import { combineReducers } from 'redux';
import generalReducer from './general/reducer';

const appReducer = combineReducers({
    general: generalReducer
});

export default appReducer;
